import { render, staticRenderFns } from "./Colorepaper.vue?vue&type=template&id=9030e2c8&scoped=true&"
import script from "./Colorepaper.vue?vue&type=script&lang=js&"
export * from "./Colorepaper.vue?vue&type=script&lang=js&"
import style0 from "./Colorepaper.vue?vue&type=style&index=0&id=9030e2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9030e2c8",
  null
  
)

component.options.__file = "Colorepaper.vue"
export default component.exports